export default {"src":"/_next/static/media/usda-verified.bb56b782.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};